import { FormField, Multiselect } from '@cloudscape-design/components'
import { FC, ReactNode } from 'react'
import { Control, Controller, UseControllerProps } from 'react-hook-form'

export type MultiselectOption = {
	label: string
	value: string
	description?: string
}

export type MultiselectOptionGroup = {
	label: string
	options: MultiselectOption[]
}

export interface FormMultiselectProps {
	label: string
	name: string
	control: Control
	options?: MultiselectOption[]
	optionGroups?: MultiselectOptionGroup[]
	placeholder: string
	defaultValue?: string
	description?: string
	info?: ReactNode
	rules?: UseControllerProps['rules']
	setFormValues: (name: string, value: any) => void
	normalizeSelectedOptions?: (
		selectedOptions: ReadonlyArray<{ label: string; value: string; description?: string }>
	) => Array<{ label: string; value: string; description?: string }>
}

const FormMultiselect: FC<FormMultiselectProps> = ({
	label,
	name,
	control,
	description,
	defaultValue,
	info,
	rules,
	options,
	optionGroups,
	placeholder,
	setFormValues,
	normalizeSelectedOptions
}) => {
	const multiselectOptions = optionGroups ?? options ?? []

	return (
		<Controller
			name={name}
			control={control}
			rules={rules}
			defaultValue={defaultValue}
			render={({ field: { name, onChange, value }, fieldState: { error } }) => {
				return (
					<FormField
						label={label}
						description={description}
						info={info}
						errorText={error?.message}
					>
						<Multiselect
							selectedOptions={value || []}
							options={multiselectOptions}
							placeholder={placeholder}
							onChange={({ detail }) => {
								const selectedOptions = normalizeSelectedOptions
									? normalizeSelectedOptions(
											detail.selectedOptions as ReadonlyArray<MultiselectOption>
										)
									: [...detail.selectedOptions]
								onChange(selectedOptions)
								setFormValues(name, selectedOptions)
							}}
						/>
					</FormField>
				)
			}}
		/>
	)
}

export default FormMultiselect
